export const CHIP_COLORS = ['type-1', 'type-2', 'type-3', 'type-4', 'type-5', 'type-6', 'type-7'];
